import React from 'react';
import styles from './styles.module.css';
import classNames from 'classnames';
import { type MessageComponentType } from './WhiteboardMessageComponent';

interface MessageProps {
  confirm?: () => void;
  confirmText?: string;
  dismiss?: () => void;
  type?: MessageComponentType;
  children: React.ReactNode;
}
const Message: React.FC<MessageProps> = ({
  children,
  confirmText,
  dismiss,
  confirm,
  type,
}) => {
  return (
    <div className={styles.messageContainer}>
      <div className={classNames(styles.message, type && styles[type])}>
        {children}
        {dismiss && (
          <aha-button
            kind='plain'
            size='small'
            onClick={dismiss}
            style={{ borderColor: 'inherit' }}
          >
            Not now
          </aha-button>
        )}
        {confirm && (
          <aha-button kind='default' size='small' onClick={confirm}>
            {confirmText ?? 'Ok'}
          </aha-button>
        )}
      </div>
    </div>
  );
};

export default Message;
